import { Box, Button, Container, TextField, useMediaQuery, useTheme } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import React, { useRef } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import {
    Controller, SubmitHandler, useForm
} from "react-hook-form";
import ApiContacts from '../../../core/api/contact/api.fb.contacts';
import { IFormInput } from '../../../models/contacts';
import Snackbar from '@mui/material/Snackbar';

export default function Contact() {
    const theme = useTheme();
    const ltxs = useMediaQuery(theme.breakpoints.down("xs"));
    const ltsm = useMediaQuery(theme.breakpoints.down("sm"));
    // const ltmd = useMediaQuery(theme.breakpoints.down("md"));
    const recaptchaRef = useRef<ReCAPTCHA>(null);
    const { REACT_APP_RECAPTCHA_KEY } = process.env;
    const reCaptchaKey = REACT_APP_RECAPTCHA_KEY as string;
    const emailRegex = RegExp(
        /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    );
    const phoneRegex = RegExp(/^(\+\d{1,3}[- ]?)?\d{10}$/)
    const defaultValues = {
        name: "",
        email: "",
        phone: "",
        msg: "",
    };

    const {
        handleSubmit,
        control,
        reset,
        formState: { errors, isValid  }
    } = useForm<IFormInput>({ defaultValues, mode: 'onChange' });

    const onSubmitWithReCAPTCHA: SubmitHandler<IFormInput> = async (data: IFormInput) => {
        const token = await recaptchaRef.current?.executeAsync();
        if(token){
        const postStatus = await ApiContacts.postContactInfo(data);
        if (postStatus){
            reset({name: "",email: "",phone: "",msg: ""});
            setOpen(true);
        }
        }
    }

    const [open, setOpen] = React.useState(false);

    // const handleClick = () => {
    //     setOpen(true);
    // };

    const handleClose = (event?, reason?) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    const action = (
        <React.Fragment>
            <Button variant="text" onClick={handleClose}>OK</Button>
        </React.Fragment>
    );

    return (
        <React.Fragment>
            <Snackbar
                open={open}
                autoHideDuration={6000}
                onClose={handleClose}
                message="Received Your Message! Will get back to you.. asap!"
                action={action}
            />
            <Container maxWidth="lg">
                <Box display="flex" flexDirection={ltsm ? "column" : "row"} className="ui-width--full" py={6}>
                    <Box display="flex" flexDirection="column">
                        <Box order={1}>
                            <h2 className="ui-typo--h2 ui-font-weight--mediu ui-nowra">Connect with me</h2>
                        </Box>
                        <Box p={2} order={ltxs ? 3 : 2}>
                            <p className="ui-typo--body1 ui-font-weight--normal app-summary">
                                <b>Let's talk </b>
                                Wanna get in touch or talk about a project?
                                Feel free to contact me via email at &thinsp;
                                <a className="ui-theme--primary" href="mailto: bhrthkshr@gmail.com">
                                    bhrthkshr@gmail.com
                                </a>
                                <br />
                                or <i>drop a line in the form.</i>
                            </p>
                        </Box>
                        <Box order={ltxs ? 2 : 3} my={1} height={ltxs ? 156 : 256} maxHeight={ltxs ? "20%" : "40%"}>
                            <img src="assets/img/undraw_Personal_text.svg" className="ui-image" alt="" />
                        </Box>
                    </Box>
                    <Box flex={1} p={2}></Box>
                    <form noValidate autoComplete="off" onSubmit={handleSubmit(onSubmitWithReCAPTCHA)} className="ui-width--full">
                        <ReCAPTCHA
                            ref={recaptchaRef}
                            size="invisible"
                            sitekey={reCaptchaKey}
                        />
                        <Box display="flex" flexDirection="column" className="ui-glassmoprhic-bg ui-padding--12 ui-border--r8">
                            <Controller
                                render={({ field }) => <TextField placeholder="Enter Your Name here."
                                    error={errors?.name?.type === 'required'} variant="outlined" label="Full Name" {...field} />}
                                name="name"
                                rules={{ required: true }}
                                control={control}
                            />
                            <div className="ui-padding--8"></div>

                            <Controller
                                render={({ field }) => <TextField error={errors?.email?.type === 'required' || errors?.email?.type === 'pattern'} placeholder="johnwick@email.com" variant="outlined" label="Email" {...field} />}
                                name="email"
                                rules={{ required: true, pattern: emailRegex }}
                                control={control}
                            />
                            <div className="ui-padding--8"></div>
                            <Controller
                                render={({ field }) => <TextField error={ errors?.phone?.type === 'pattern'}  placeholder="9999 888 777" variant="outlined" label="Mobile Number" {...field} />}
                                name="phone"
                                rules={{ pattern: phoneRegex }}
                                control={control}
                            />
                            <div className="ui-padding--8"></div>
                            <Controller
                                render={({ field }) => <TextField multiline
                                    error={errors?.msg?.type === 'required'}
                                    rows={4} variant="outlined" label="Message" {...field} />}
                                name="msg"
                                rules={{ required: true }}
                                control={control}
                            />
                        </Box>
                        <div className="ui-padding--12"></div>
                        <div className="ui-width--156">
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                disabled={!isValid}
                                size="large"
                                fullWidth
                                endIcon={<SendIcon className="ui-icon--18" />}
                            >
                                Send
                            </Button>
                        </div>
                    </form>
                </Box>
            </Container>
        </React.Fragment>
    )
}
